// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federherstellungstechniken/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federherstellungstechnikenDE: PageEntry = {
  id: "post.federherstellungstechniken",
  locale: "de",
  slug: "federherstellungstechniken",
  seo: {
    title: "Glossar: Federherstellungstechniken einfach erklärt | Dietz GmbH",
    description: "Federherstellungstechniken umfassen verschiedene Verfahren und Prozesse, die bei der Produktion von Federn eingesetzt werden. Dazu gehören Drahtziehen, Biegen, Wickeln, Wärmebehand",
  },
  type: "post",
  h1: "Glossar: Federherstellungstechniken einfach erklärt",
  intro: "Federherstellungstechniken umfassen verschiedene Verfahren und Prozesse, die bei der Produktion von Federn eingesetzt werden. Dazu gehören Drahtziehen, Biegen, Wickeln, Wärmebehandlung und Oberflächenbeschichtung. Jede Technik hat spezifische Anwendungen und Vorteile, abhängig von den Anforderungen der Feder und der Endanwendung. Die fortschreitende Technologie in der Fertigungsindustrie hat zu innovativen Herstellungstechniken geführt, die die Präzision, Effizienz und Qualität der produzierten Federn verbessern. Ein Verständnis der verschiedenen Federherstellungstechniken ist entscheidend für die Auswahl der geeigneten Methode je nach den spezifischen Anforderungen eines Projekts.",
  blocks: [

  ],
};
